export type SocialProfilePlatform = 'linkedin' | 'twitter';

const socialProfileDomains: Record<SocialProfilePlatform, string[]> = {
    linkedin: ['linkedin.com'],
    twitter: ['twitter.com', 'x.com'],
};

const sanitizeSocialProfileSlug = (value: string) => {
    const slug = value.trim().replace(/^@/, '');

    return slug && !/[/?#\s]/.test(slug) ? slug : '';
};

export const extractSocialProfileSlug = (value: string | undefined, platform: SocialProfilePlatform) => {
    const trimmedValue = value?.trim();

    if (!trimmedValue) {
        return '';
    }

    try {
        const url = new URL(/^https?:\/\//i.test(trimmedValue) ? trimmedValue : `https://${trimmedValue}`);
        const hostname = url.hostname.toLocaleLowerCase();
        const hasSupportedHostname = socialProfileDomains[platform].some(
            (domain) => hostname === domain || hostname.endsWith(`.${domain}`),
        );

        if (!hasSupportedHostname) {
            return sanitizeSocialProfileSlug(trimmedValue);
        }

        const pathSegments = url.pathname.split('/').filter(Boolean);
        const linkedInCompanySegmentIndex = pathSegments.findIndex(
            (segment) => segment.toLocaleLowerCase() === 'company',
        );
        const candidate =
            platform === 'linkedin'
                ? linkedInCompanySegmentIndex >= 0
                    ? pathSegments[linkedInCompanySegmentIndex + 1]
                    : pathSegments.at(-1)
                : pathSegments[0];

        return sanitizeSocialProfileSlug(candidate ? decodeURIComponent(candidate) : '');
    } catch {
        return sanitizeSocialProfileSlug(trimmedValue);
    }
};
